"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    MenuContext: ()=>MenuContext,
    MenuProvider: ()=>MenuProvider,
    useMenuContext_unstable: ()=>useMenuContext_unstable
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _reactContextSelector = require("@fluentui/react-context-selector");
const MenuContext = /*#__PURE__*/ (0, _reactContextSelector.createContext)(undefined);
const menuContextDefaultValue = {
    open: false,
    setOpen: ()=>false,
    checkedValues: {},
    onCheckedValueChange: ()=>null,
    isSubmenu: false,
    triggerRef: {
        current: null
    },
    menuPopoverRef: {
        current: null
    },
    mountNode: null,
    triggerId: '',
    openOnContext: false,
    openOnHover: false,
    hasIcons: false,
    hasCheckmarks: false,
    inline: false,
    persistOnItemClick: false
};
const MenuProvider = MenuContext.Provider;
const useMenuContext_unstable = (selector)=>(0, _reactContextSelector.useContextSelector)(MenuContext, (ctx = menuContextDefaultValue)=>selector(ctx)); //# sourceMappingURL=menuContext.js.map

//# sourceMappingURL=menuContext.js.map